import React from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

interface ProductCellActionProps {
  productData: any; // Replace 'any' with the appropriate type for your data
  onView?: (data: any) => void; // Make onView optional
  onEdit: (data: any) => void;
  onDelete: (data: any) => void;
}

const ProductCellActions: React.FC<ProductCellActionProps> = ({ productData: data, onView, onDelete }) => {
  return (
    <ul className="list-unstyled hstack gap-1 mb-0">
      {onView && (
        <li id="viewtooltip">
          <Link
            to={`/view-product/${data.id}`} // Use Link for navigation
            className="btn btn-sm btn-soft-primary"
          >
            <i className="mdi mdi-eye-outline"></i>
            <UncontrolledTooltip placement="top" target="viewtooltip">
              View
            </UncontrolledTooltip>
          </Link>
        </li>
      )}

      <li id="edittooltip">
        <Link
          to={`/edit-product/${data.id}`} // Use Link for navigation
          className="btn btn-sm btn-soft-info"
        >
          <i className="mdi mdi-pencil-outline" />
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </Link>
      </li>

      <li id="deleteTooltip">
        <Link
          to="#"
          className="btn btn-sm btn-soft-danger"
          onClick={() => onDelete(data)}
        >
          <i className="mdi mdi-delete" />
          <UncontrolledTooltip placement="top" target="deleteTooltip">
            Delete
          </UncontrolledTooltip>
        </Link>
      </li>
    </ul>
  );
};

export default ProductCellActions;